import styled from 'styled-components';

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ColorDot = styled.span<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 12px;
  background: ${({ $color }) => $color};
  display: inline-block;
  box-shadow: 0 2px 6px rgba(2, 6, 23, 0.08);
`;

export const HeaderMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ColumnName = styled.span`
  font-weight: 700;
`;
